
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import sidebarMenu from './sidebarMenu.vue'
import sidebarMenuShrink from './sidebarMenuShrink.vue'

@Component({
  components: { sidebarMenu, sidebarMenuShrink }
})
export default class ShrinkableMenu extends Vue {
  name: string = 'shrinkableMenu'
  @Prop() collapse: boolean
  @Prop({ required: true, type: Array }) menuList: Array<any>
  @Prop({ type: Array }) openeds: Array<string>
  @Prop({ type: Function }) beforePush: Function

  @Emit('on-change')
  handleChange(name: string) {
    if (!name) {
      return
    }
    let willpush = true
    if (this.beforePush !== undefined) {
      if (!this.beforePush(name)) {
        willpush = false
      }
    }
    if (willpush) {
      this.$router.push({ name: name })
    }
  }
}
